import { Icon, IconProps } from '@chakra-ui/react'

export const PlayIcon = (props: IconProps) => (
  <Icon viewBox="0 -960 960 960" boxSize={6} fill="currentColor" {...props}>
    <path d="M320-200v-560l440 280-440 280Z" />
  </Icon>
)

export const PauseIcon = (props: IconProps) => (
  <Icon viewBox="0 -960 960 960" boxSize={6} fill="currentColor" {...props}>
    <path d="M560-200v-560h160v560H560Zm-320 0v-560h160v560H240Z" />
  </Icon>
)
